<template>
  <div id="invoice">
    <div class="invoice-box" ref="invoiceBox">
      <!-- Download -->
      <div class="download_icon" @click="downLoadInvoice()">
        <span>Download</span>
        <!-- <img src="@/assets/icons/download.svg" alt="Download Your Invoice"> -->
      </div>
      <!--  -->
      <div class="invoice_wrapper">
        <div class="my_company">
          <span style="font-size: 2rem; font-weight: bolder">
            <editable
              id="myCompanyName"
              :content="myCompany.name"
              @update="myCompany.name = $event"
            /> </span
          ><br />
          <editable
            id="myCompanyAddress"
            :content="myCompany.address"
            @update="myCompany.address = $event"
          />
        </div>
        <div class="invoice_info">
          <span
            style="
              font-size: 2rem;
              font-weight: bolder;
              text-transform: uppercase;
            "
          >
            <editable
              id="invoiceName"
              :content="invoice.name"
              @update="invoice.name = $event"
            /> </span
          ><br />
          Date:
          <editable
            id="invoiceDate"
            :content="invoice.date"
            @update="invoice.date = $event"
          /><br />
          Invoice #:
          <editable
            id="invoiceSerialNumber"
            :content="invoice.serialNumber"
            @update="invoice.serialNumber = $event"
          />
        </div>
      </div>
      <div class="bill_wrapper">
        <div class="bill_info">
          <span style="font-size: 1.2rem; font-weight: bolder; margin: -12px 0"
            >Bill to:</span
          >
          <br />
          <editable
            id="recipient"
            :content="recipient"
            @update="recipient = $event"
          />
        </div>
      </div>
      <div class="description_wrapper">
        <div class="heading">
          <span>Description</span>
          <span>
            <span>Amount (</span>
            <editable
              id="currency"
              :content="currency"
              @update="currency = $event"
            />
            <span>)</span>
          </span>
        </div>
        <draggable
          :list="items"
          :animation="200"
          handle=".content"
          ghost-class="moving-item"
        >
          <div class="content" v-for="(item, index) in items" :key="item.id">
            <editable
              class="content__name"
              :content="item.name"
              @update="item.name = $event"
            />
            <cleave
              v-model="item.amount"
              class="content__amount"
              :options="options.number"
              inputmode="decimal"
            />
            <!-- <editable
              class="content__amount"
              :content="item.amount"
              @update="item.amount = $event"
            /> -->
            <div
              class="add_icon"
              v-if="items.length === index + 1"
              @click="addNewItem()"
            >
              <img src="@/assets/icons/plus-square.svg" alt="" />
            </div>
            <span
              v-if="items.length > 1"
              class="delete_icon"
              @click="items.splice(index, 1)"
              >
              <img src="@/assets/icons/delete.svg" alt="">
            </span>
          </div>
        </draggable>
        <div class="total">
          <span>Total: ${{ totalAmount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
import draggable from "vuedraggable";
import Cleave from 'vue-cleave-component';
// import domtoimage from "dom-to-image";

import Editable from "@/components/Editable";

export default {
  name: "Invoice",
  components: {
    Editable,
    draggable,
    Cleave
  },
  data() {
    return {
      options: {
        number: {
          prefix: '$',
          numeral: true,
          delimiter: '',
          numeralPositiveOnly: true,
          noImmediatePrefix: true,
          rawValueTrimPrefix: true,
          numeralIntegerScale: 8,
          numeralDecimalScale: 2
        }
      },
      // 
      invoiceValue:
        JSON.parse(localStorage.getItem('invoiceValue')) || {
          name: "",
          date: "",
          serialNumber: "",
        }
      ,
      myCompanyValue: 
        JSON.parse(localStorage.getItem('myCompanyValue')) || {
          name: "",
          address: "",
        }
      ,
      recipientValue:
        localStorage.getItem('recipientValue') || "",
      currencyValue:
        localStorage.getItem('currencyValue') || '',
      items: [
        {
          id: Math.random().toString(36).substr(2, 9),
          name: "Monthly Salary - October",
          amount: "5000.00",
        },
      ],
    };
  },
  computed: {
    totalAmount() {
      const result = this.items
        .map((item) => (item.amount === "" ? 0.0 : parseFloat(item.amount)))
        .reduce((acc, curr) => {
          return acc + curr;
        }, 0);
      return isNaN(result) ? '0.00' : result.toFixed(2);
    },
    invoice: {
      get() {
        return this.invoiceValue;
      },
      set() {}
    },
    myCompany: {
      get() {
        return this.myCompanyValue;
      },
      set() {}
    },
    recipient: {
      get() {
        return this.recipientValue;
      },
      set(value) {
        this.recipientValue = value;
        localStorage.setItem('recipientValue', value)
      }
    },
    currency: {
      get() {
        return this.currencyValue;
      },
      set(value) {
        this.currencyValue = value;
        localStorage.setItem('currencyValue', value)
      }
    }
  },
  watch: {
    invoice: {
      deep: true,
      handler(newVal) {
        localStorage.setItem('invoiceValue', JSON.stringify(newVal))
      }      
    },
    myCompany: {
      deep: true,
      handler(newVal) {
        localStorage.setItem('myCompanyValue', JSON.stringify(newVal))
      }      
    }
  },
  methods: {
    isNaN(value) {
      let n = Number(value);
      return n !== n;
    },
    addNewItem() {
      const emptyItem = {
        id: Math.random().toString(36).substr(2, 9),
        name: "Item's description",
        amount: "0.00",
      };
      this.items.push(emptyItem);
    },
    downLoadInvoice() {
      let that = this;
      // domtoimage.toBlob(this.$refs.invoice, {
      //   width: this.$refs.invoice.clientWidth,
      //   height: this.$refs.invoice.clientHeight
      // }).then(function (blob) {
      //   saveAs(blob, `[INVOICE - ${that.myCompany.name}].png`)
      // })
      html2canvas(this.$refs.invoiceBox, { height: this.$refs.invoiceBox.clientHeight })
        .then(function (canvas) {
          saveAs(canvas.toDataURL(), `[INVOICE - ${that.myCompany.name}].png`);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
html,
body {
  margin: 0;
  padding: 0;
}
/* Contenteditable setting */

/* [contenteditable="true"]:focus {
  padding: .2rem 0;
} */
[contenteditable] {
  outline: 0 solid transparent;
}

// Placeholder
#myCompanyName:empty::before {
  content: "My company name";
}
#myCompanyAddress:empty::before {
  content: "My company's address & email";
}
#invoiceName:empty::before {
  content: "Invoice";
}
#invoiceDate:empty::before {
  content: "Invoice date";
}
#invoiceSerialNumber:empty::before {
  content: "Serial number";
}
#recipient:empty::before {
  content: "Recipient's address & email";
}
#currency:empty::before {
  content: "Currency";
}

// 
#myCompanyName:empty:focus,
#myCompanyAddress:empty:focus,
#invoiceName:empty:focus,
#invoiceDate:empty:focus,
#invoiceSerialNumber:empty:focus,
#recipient:empty:focus,
#currency:empty:focus {
  color: lightgray;
}

// 
#myCompanyName:focus,
#myCompanyAddress:focus,
#invoiceName:focus,
#invoiceDate:focus,
#invoiceSerialNumber:focus,
#recipient:focus,
#currency:focus {
  color: #555;
  // border: 2px dashed lightgray;
}

// ghost class for raggable setting
.moving-item {
  opacity: 0;
  background: #fff;
  input[type="text"] {
    background: transparent;
  }
}

#invoice {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.invoice-box {
  position: relative;
  min-width: 800px;
  max-width: 800px;
  width: 800px;
  // margin: auto;
  padding: 30px;
  // border: 1px solid #eee;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #555;
  background: white;
  .download_icon {
    position: absolute;
    bottom: -80px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 120px;
    height: 40px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2ab6fb;
    color: #fff;
    font-weight: bold;
  }
}
/*  */
.invoice_wrapper {
  display: flex;
  justify-content: space-between;
  margin: 0 5px;
  padding: 0 4px;
  .invoice_info {
    text-align: right;
  }
}
.bill_wrapper {
  margin: 2rem 0;
  .bill_info {
    // display: flex;
    // flex-direction: column;
    margin: 0 5px;
    padding: 0 4px;
    line-height: 24px;
  }
}
.description_wrapper {
  display: flex;
  flex-direction: column;
  border: 2px solid rgba(0, 0, 0, 0.4);
  .heading {
    display: flex;
    justify-content: space-between;
    background: #eee;
    border-bottom: 1px solid #ddd;
    font-weight: bold;
    padding: 8px 10px;
  }
  .content {
    display: flex;
    justify-content: space-between;
    padding: 8px 10px;
    position: relative;
    border-bottom: 1px solid #ddd;
    cursor: grab;
    &:hover {
      .add_icon {
        display: block;
      }
      .delete_icon {
        display: block;
      }
    }
    &__name,
    &__amount {
      cursor: pointer;
    }
    &__amount {
      outline: none;
      outline-color: currentcolor;
      -webkit-appearance: none;
      border: 0 solid transparent;
      background: transparent;
      padding: 0;
      vertical-align: middle;
      font-size: 1rem;
      text-align: right;
      font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
    }
    .add_icon {
      display: none;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: -16px;
      cursor: pointer;
      font-size: 1.5rem;
    }
    .delete_icon {
      display: none;
      position: absolute;
      top: 7px;
      right: -16px;
      cursor: pointer;
    }
  }
  .total {
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid #ddd;
    font-weight: bold;
    padding: 8px 10px;
  }
}
</style>
